import { RESOURCE_LIBRARy_APIS } from "libs/apis/resource-library.api";
import { USER_APIS } from "libs/apis/users.api";
import { useNavigate } from "react-router-dom";
import { successToaster } from "utils/helpers/common/alert-service";
import { CreateResourceLibraryDTO } from "utils/helpers/models/resource-library/resource-library.dto";
import { UserDTO } from "utils/helpers/models/users/user.dto";

const useResourceLibrary = () => {
  const navigate = useNavigate();
  const uploadFile = async (params: FormData): Promise<string | null> => {
    try {
      const response = await RESOURCE_LIBRARy_APIS.uploadFile(params);
      const { status = false, message = "", data = null } = response || {};

      if (status && data) {
        return data;
      }

      return null;
    } catch (error) {
      console.error("Upload failed", error);
      return null;
    }
  };

  const createResourceLibrary = async (body: CreateResourceLibraryDTO) => {
    const response = await RESOURCE_LIBRARy_APIS.createResourceLibrary(body);
    const { status = false } = response || {};
    if (status) {
      navigate(-1);
    }
  };

  const getResourceLibrary = async (
    setData: Function,
    queryParams: any = {},
    setFilters?: Function
  ) => {
    const response = await RESOURCE_LIBRARy_APIS.getResourceLibrary(
      queryParams
    );
    const { status = false, data = null } = response || {};
    if (status) {
      const { content = [], page = 0, size = 10 } = data || {};
      setData(content);
      console.log(content)
      if (setFilters && typeof setFilters === "function") {
        setFilters((prevFilters) => ({ ...prevFilters, page, size }));
      }
    }
  };

  const editResourceLibrary = async (id: number, queryParams: any = {}) => {
    const response = await RESOURCE_LIBRARy_APIS.editResourceLibrary(
      id,
      queryParams
    );
    const { status = false } = response || {};
    if (status) {
      navigate(-1);
    }
  };

  const getResourceLibraryById = async (id: number, setData: Function) => {
    const response = await RESOURCE_LIBRARy_APIS.getResourceLibraryById(id);
    const { status = false, data = {} } = response || {};
    if (status) {
      setData(data);
    }
  };

  return {
    uploadFile,
    createResourceLibrary,
    getResourceLibrary,
    getResourceLibraryById,
    editResourceLibrary,

  };
};

export default useResourceLibrary;
